function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ThunkHelper } from 'invision-core';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import { values } from 'ramda';
export var SET_SELECTED_POLICY_COUNTER = 'SET_SELECTED_POLICY_COUNTER';
export var setSelectedPolicyCounter = function setSelectedPolicyCounter(policyCounter) {
  return {
    type: SET_SELECTED_POLICY_COUNTER,
    payload: policyCounter
  };
};
export var UPDATE_POLICY_COUNTER_BALANCE = {
  BEGIN: 'UPDATE_POLICY_COUNTER_BALANCE_BEGIN',
  SUCCESS: 'UPDATE_POLICY_COUNTER_BALANCE_SUCCESS',
  FAILURE: 'UPDATE_POLICY_COUNTER_BALANCE_FAILURE'
};
export var updatePolicyCounterBalance = function updatePolicyCounterBalance(requestData, customerId) {
  return function (dispatch) {
    return ThunkHelper(dispatch, values(UPDATE_POLICY_COUNTER_BALANCE), {
      method: 'post',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      url: 'SubscriberManagement/UpdatePolicyCounterBalance',
      data: requestData
    });
  };
};